const signinDescription = `研究に関心を持たれた方はアカウント登録をお願いします。
登録後に詳細なご案内をお送りします。
`;

const dashboardTitle = `サウナ浴と高温浴が精液所見に与える影響
:ランダム化比較試験`;

const dashboardTitleHeaderClassName = "text-xs sm:text-sm leading-tight";

const contactInfo = `北海道大学大学院医学研究院公衆衛生学教室
研究担当者：前田 恵理
TEL：011-706-5068　（受付：平日 9:00〜17:00）
`;
// const contactInfo = `
// 〒101-0047 東京都千代田区内神田2-4-6 WTC内神田ビル
// ORSO大学医学部内科
// 研究責任者　田中太郎

// 電話番号	03-1234-5678
// FAX番号	03-4321-8765
// `;

const contactEmail = "sapporo_cohort@pop.med.hokudai.ac.jp";

// const explainMovieUrl = "https://www.youtube.com/embed/bV8jIopHZEI?s";
const explainMovieUrl = ""

const newMessageScreenValues = [
  {
    label: "予約",
    value: `${process.env.NEXT_PUBLIC_BASE_URL}/dashboard/reservations`,
  },
];

export {
  contactEmail,
  contactInfo,
  dashboardTitle,
  dashboardTitleHeaderClassName,
  explainMovieUrl,
  newMessageScreenValues,
  signinDescription,
};
